var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.528 7.66398L8.33201 0.468C8.03999 0.18 7.63998 0 7.19999 0H1.60001C0.715987 0 0 0.715987 0 1.60001V7.19999C0 7.64399 0.18 8.04401 0.472012 8.33201L7.67201 15.532C7.96001 15.82 8.36002 16 8.80001 16C9.23999 16 9.64402 15.82 9.93202 15.532L15.532 9.93202C15.82 9.64001 16 9.24003 16 8.80001C16 8.35601 15.82 7.95599 15.528 7.66398ZM2.80001 4.00001C2.136 4.00001 1.60001 3.46402 1.60001 2.80001C1.60001 2.136 2.136 1.60001 2.80001 1.60001C3.46402 1.60001 4.00001 2.136 4.00001 2.80001C4.00001 3.46402 3.46398 4.00001 2.80001 4.00001Z",
    fill: "#current "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTag);
export default __webpack_public_path__ + "static/media/Add-tag.592e9befcb1ebac6ec8553ea37d77160.svg";
export { ForwardRef as ReactComponent };